import * as types from "src/store/types/configuracoes";

const INITIAL_STATE = {
  loading: false,
  empresa: {},
  configuracoes: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CONF_LOADING:
      return { ...state, loading: action.payload };
    case types.CONF_SET_CONFIGURACOES:
      return { ...state, configuracoes: action.payload };
    case types.CONF_SET_EMPRESA:
      return { ...state, empresa: action.payload };
    default:
      return state;
  }
};
